module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-external-link-411c799f41c21263f2902b43969b3f09.png";